import React, { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { FiCheck, FiSend, FiX } from "react-icons/fi";
import { getHost } from "../utils/utils";

const getToken = () => localStorage.getItem("jwt");

const TestPingButton = ({ url, clientId }) => {
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  useEffect(() => {
    setState("idle");
    setError("");
  }, [url, clientId]);

  const send = async () => {
    setState("sending");
    setError("");
    try {
      const res = await fetch(`${getHost()}/api/webhooks/test`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({ client_id: clientId, webhook_url: url }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.success) {
        setState("ok");
      } else {
        setState("error");
        setError(data.error || `Error ${res.status}`);
      }
    } catch {
      setState("error");
      setError("Network error");
    }
  };

  const variant = state === "ok" ? "outline-success" : state === "error" ? "outline-warning" : "outline-info";
  const title = state === "ok" ? "Test ping sent" : state === "error" ? error : "Send a test ping";

  return (
    <Button
      variant={variant}
      size="sm"
      onClick={send}
      disabled={!url || !url.trim() || !clientId || state === "sending"}
      title={title}
      className="d-inline-flex align-items-center gap-1 text-nowrap"
    >
      {state === "sending" ? (
        <Spinner animation="border" size="sm" />
      ) : state === "ok" ? (
        <FiCheck />
      ) : state === "error" ? (
        <FiX />
      ) : (
        <FiSend />
      )}
      <span>Test</span>
    </Button>
  );
};

export default TestPingButton;
